import React, {Component} from 'react';
import {
    AK,
    BA,
    BoltAvtoPVx3,
    Cell,
    EK,
    EKlapanL,
    EKlapanR,
    ElMeterCell,
    EM34,
    GB,
    Progress,
    Pump,
    RV,
    Tap,
    TapB,
    TapDrain,
    TapG,
    TO,
    Uso,
    Valve,
    ValveCheck,
    Vent,
    WinterSummer
} from '../';

export default class HydroTeplo extends Component {

    render() {
        const styles = this.props.styles;

        return (
            <span>
                <Vent power={this.props.params['tc_8_97_61']}
                      fault={this.props.params['tc_8_97_42']}
                      div_id={styles.canvas1}/>
                <Vent power={this.props.params['tc_8_97_62']}
                      fault={this.props.params['tc_8_97_43']}
                      div_id={styles.canvas2}/>
                <EK ps={[this.props.params['tc_8_97_44'], this.props.params['tc_8_92_201']]}
                    canvas_id={styles.canvas3}/>
                <EK ps={[this.props.params['tc_8_97_45'], this.props.params['tc_8_93_201']]}
                    canvas_id={styles.canvas4}/>
                <EKlapanL ps={[this.props.params['tc_8_92_201']]} canvas_id={styles.canvas5}/>
                <EKlapanR ps={[this.props.params['tc_8_93_201']]} canvas_id={styles.canvas6}/>
                <EM34 ps={[this.props.params['tc_8_97_64']]} canvas_id={styles.canvas7}/>
                <Pump power={this.props.params['tc_8_90_17']} fault={this.props.params['tc_8_90_27']}
                      div_id={styles.canvas8}/>
                <Pump power={this.props.params['tc_8_90_11']} fault={this.props.params['tc_8_90_26']}
                      div_id={styles.canvas9}/>
                <Pump power={this.props.params['tc_8_91_11']} fault={this.props.params['tc_8_91_26']}
                      div_id={styles.canvas10}/>
                <Pump power={this.props.params['tc_8_91_17']} fault={this.props.params['tc_8_91_27']}
                      div_id={styles.canvas11}/>
                <EM34 ps={[this.props.params['tc_8_97_63']]} canvas_id={styles.canvas12}/>
                <WinterSummer winter={this.props.params['tc_8_97_21']} div_id={styles.canvas13}/>
                <BA ps={[this.props.params['tc_8_97_47'], this.props.params['tc_8_97_77'], this.props.params['tc_8_97_46']]}
                    div_id={styles.canvas14}
                    canvas_id="Random1488"/>
                <GB canvas_id={styles.canvas15}/>
                <AK canvas_id={styles.canvas16}/>
                <Tap canvas_id={styles.canvas17}/>
                <TapB canvas_id={styles.canvas18}/>
                <TapG canvas_id={styles.canvas19}/>
                <RV canvas_id={styles.canvas20}/>
                <Valve caption="З№1" div_id={styles.canvas21} canvas_id="c1"/>
                <Valve caption="З№2" div_id={styles.canvas22} canvas_id="c2"/>
                <Valve caption="З№3" div_id={styles.canvas23} canvas_id="c3"/>
                <Valve caption="З№4" div_id={styles.canvas24} canvas_id="c4"/>
                <Valve caption="З№5" div_id={styles.canvas25} canvas_id="c5"/>
                <Valve caption="З№6" div_id={styles.canvas26} canvas_id="c6"/>
                <TapDrain canvas_id={styles.canvas27}/>
                <ValveCheck canvas_id={styles.canvas28}/>
                <ValveCheck canvas_id={styles.canvas29}/>
                <BoltAvtoPVx3 canvas_id={styles.canvas30}/>
                <TO canvas_id={styles.canvas31}/>
                <Uso fault={this.props.params['tc_8_94_200']} direction="left" caption="Форт-04.1"
                     div_id={styles.canvas32}/>
                <Uso fault={this.props.params['tc_8_96_200']} direction="left" caption="Эконом-04-5"
                     div_id={styles.canvas33}/>
                {/*styles hydro: 42, 41. teplo: 34,35*/}
                <ElMeterCell ps={this.props.params['ti_8_94_5']} div_id={styles.canvas4234}/>
                <Progress ps={this.props.params['ti_8_96_64']} max={10} min={2} div_id={styles.canvas4135}/>
                {
                    this.props.cellData.map((childData, i) => {
                        return <Cell
                            key={i}
                            onClick={childData.chartPs && this.props.parentScreen.openModal.bind(this.props.parentScreen, childData.chartPs)}
                            ps={this.props.params[childData.ps]}
                            div_id={childData.div_id}
                            caption={childData.caption}
                            hint={childData.hint}
                            className={childData.className}
                        />
                    })
                }
                <div className="capt" id={styles.capt1}>Температура в узле ВЕНА</div>
                <div className="capt" id={styles.capt2}>Температура зовнішнього повітря</div>
                <div className="capt" id={styles.capt3}>Температура у контрольному приміщенні</div>
                <div className="capt" id={styles.capt4}>В1</div>
                <div className="capt" id={styles.capt5}>В2</div>
                <div className="capt" id={styles.capt6}>ЕК1</div>
                <div className="capt" id={styles.capt7}>ЕК2</div>
                <div className="capt" id={styles.capt8}>ЕМ1</div>
                <div className="capt" id={styles.capt9}>ЕМ2</div>
                <div className="capt" id={styles.capt10}>ТО</div>
                <div className="capt" id={styles.capt11}>від ХВП</div>
                <div className="capt" id={styles.capt12}>ЕМ4</div>
                <div className="capt" id={styles.capt13}>КТ</div>
                <div className="capt" id={styles.capt14}>Н2</div>
                <div className="capt" id={styles.capt15}>Н1</div>
                <div className="capt" id={styles.capt16}>Н3</div>
                <div className="capt" id={styles.capt17}>Н4</div>
                <div className="capt" id={styles.capt18}>від ХВП</div>
                <div className="capt" id={styles.capt19}>від гребінки</div>
                <div className="capt" id={styles.capt21}>ЕМ3</div>
                <div className="capt" id={styles.capt22}>до гребінки</div>
            </span>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/entries/HydroTeplo/index.js